// extracted by mini-css-extract-plugin
module.exports = {"fileStatusContainer":"userOnboardingFileHistory_fileStatusContainer__P_jHU","loadMoreBtnContainer":"userOnboardingFileHistory_loadMoreBtnContainer__1_P7T"};